// Phase 6.C — 작업일정 / 전처리 sub-route.
// 시안 design/v3/SchedulePage.jsx SECTIONS[3] (id="prep").
// 부족재고 자동연결 alert 가 SectionCard 내부에서 자동 노출 (autoStock=true).

import { AlertBanner, EmptyState } from '../../components/primitives';
import { useViewport } from '../../lib/useViewport';
import { findSection } from './data';
import { SectionCard } from './SectionCard';

export function SchedulePrepRoute() {
  const isMobile = useViewport() === 'mobile';
  const section = findSection('prep');
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <AlertBanner
        tone="info"
        message="전처리 일정 — 부족재고 자동연결 (출근시간 자동 +1h). 실 재고 프로그램 부족재고 연동은 Phase 7 schedule 모델 + scheduler 도입 후 활성."
      />
      {section ? (
        <SectionCard section={section} isMobile={isMobile} />
      ) : (
        <EmptyState
          icon="knife"
          title="등록된 전처리 일정이 없습니다"
          description="작업일정은 사장/직원이 직접 등록하는 회사별 격리 영역입니다. Phase 7 backend 도입 후 등록 + 부족재고 자동연결이 활성됩니다."
        />
      )}
    </div>
  );
}
